import MaterialComponent from '../../views/Material.vue'

export default {
  path: '/material',
  name: 'material',
  component: MaterialComponent,
}
